import { getTelemetry } from '@cian/telemetry/browser';
import { getCLS, getFID, getLCP, getFCP, getTTFB, Metric } from 'web-vitals';

export function initMetrics() {
  const telemetry = getTelemetry();

  function report(metric: Metric) {
    telemetry.timer(`vitals.${metric.name}`, metric.value);
  }

  getCLS(report);
  getFID(report);
  getLCP(report);
  getFCP(report);
  getTTFB(report);
}
